/*
 * fn: getRouteTemplateSegments
 *
 * Breaks a template string into segment options via regex
 *
 * Segment options are literal, optional, or required and used by build and parse fns
 *
 */

type SegmentType = {
  type: 'literal' | 'optional' | 'required'
  value?: string
}

const TEMPLATE_REGEX = /\[\[[a-zA-Z0-9]+\]\]|\[[a-zA-Z0-9]+\]|[a-zA-Z0-9-]+/g
const SEGMENT_REGEX = /^(?:\[\[([a-zA-Z0-9]+)\]\]|\[([a-zA-Z0-9]+)\]|([a-zA-Z0-9-]+))$/

export const getRouteTemplateSegments = (template: string) => {
  const segments = template.match(TEMPLATE_REGEX) ?? []

  const results = segments.map<SegmentType>((seg) => {
    const match = seg.match(SEGMENT_REGEX)
    if (match?.[1]) return { type: 'optional', value: match[1] }
    if (match?.[2]) return { type: 'required', value: match[2] }
    return { type: 'literal', value: match?.[3] }
  })

  return results
}
